<div class="vhplayer-danmaku-setting {{ options.isLight ? 'is-light' : '' }}">
  <!-- 显示区域 -->
  <div class="vhplayer-danmaku-setting__row">
    <div class="vhplayer-danmaku-setting__title">{{ tran('displayArea') }}</div>
    <div class="vhplayer-danmaku-setting__display-area">
      {{ each displayArea }}
      <div
        class="vhplayer-danmaku-setting__display-area__item {{
          options.positionRange.join() === $value.value.join() ? 'active' : ''
        }}"
        data-value="{{ $value.value.join() }}"
      >
        <span class="vhplayer-danmaku-setting__display-area__icon {{ $value.icon }}"></span>
        <span class="vhplayer-danmaku-setting__display-area__label">{{ tran($value.label) }}</span>
      </div>
      {{ /each}}
    </div>
  </div>

  <!-- 不透明度 -->
  <div class="vhplayer-danmaku-setting__row">
    <div class="vhplayer-danmaku-setting__title">{{ tran('opaticy') }}</div>
    <div class="vhplayer-danmaku-setting__opaticy">
      <div class="vhplayer-danmaku-setting__opaticy-slider">
        <div class="vhplayer-danmaku-setting__opaticy-slider__runway">
          <div class="vhplayer-danmaku-setting__opaticy-slider__bar" style="width: {{ options.opacity }}%"></div>
          <div class="vhplayer-danmaku-setting__opaticy-slider__button-wrapper" style="left: {{ options.opacity }}%">
            <div class="vhplayer-danmaku-setting__opaticy-slider__button"></div>
          </div>
        </div>
      </div>
      <div class="vhplayer-danmaku-setting__opaticy-label">{{ options.opacity }}%</div>
    </div>
  </div>

  <!-- 字体大小 -->
  <div class="vhplayer-danmaku-setting__row">
    <div class="vhplayer-danmaku-setting__title">{{ tran('fontSize') }}</div>
    <div class="vhplayer-danmaku-setting__font">
      {{ each fontSizeArr }}
      <div
        class="vhplayer-danmaku-setting__font__item {{ $value.fontSize === options.fontSize ? 'active' : '' }}"
        data-font-size="{{ $value.fontSize }}"
      >
        <div class="vhplayer-danmaku-setting__font__item__radio">
          <div class="vhplayer-danmaku-setting__font__item__radio-inner"></div>
        </div>
        <div class="vhplayer-danmaku-setting__font__item__text">{{ tran($value.label) }}</div>
      </div>
      {{ /each }}
    </div>
  </div>

  <!-- 弹幕颜色 -->
  <div class="vhplayer-danmaku-setting__row">
    <div class="vhplayer-danmaku-setting__title">{{ tran('color') }}</div>
    <div class="vhplayer-danmaku-setting__color">
      {{ each colorArr }}
      <div
        class="vhplayer-danmaku-setting__color__item {{ $value.color === options.color ? 'active' : '' }}"
        data-color="{{ $value.color }}"
      >
        <div class="vhplayer-danmaku-setting__color-square" style="background-color:{{ $value.color }};"></div>
      </div>
      {{ /each }}
    </div>
  </div>

  <!-- 弹幕速度 -->
  <div class="vhplayer-danmaku-setting__row">
    <div class="vhplayer-danmaku-setting__title">{{ tran('speed') }}</div>
    <div class="vhplayer-danmaku-setting__speed">
      {{ each speedArr }}
      <div
        class="vhplayer-danmaku-setting__speed__item {{ $value.speed === options.speed ? 'active' : '' }}"
        data-speed="{{ $value.speed }}"
      >
        <div class="vhplayer-danmaku-setting__speed__item__radio">
          <div class="vhplayer-danmaku-setting__speed__item__radio-inner"></div>
        </div>
        <div class="vhplayer-danmaku-setting__speed__item__text">{{ tran($value.label) }}</div>
      </div>
      {{ /each }}
    </div>
  </div>
</div>
